<ng-container *screenSizes="let size">
  <!-- SLIDE EMPTY VIEW (ADD MORE) -->
  <ng-container *ngIf="!item || !item.url">
    <img
      class="fadeIn object-none"
      src="assets/default_card_thumbnail.png"
    />
    <!-- ADD BUTTON -->
    <button
      *ngIf="enableAddButton"
      mat-icon-button
      class="fadeIn absolute top-3 right-3 flex w-6 h-6 min-h-6 bg-primary text-on-primary"
      (click)="parent.emitAddItem()"
      [matTooltip]="'Adicionar' | transloco"
    >
      <mat-icon
        class="icon-size-4 text-current"
        svgIcon="fontawesome_solid:plus"
      />
    </button>
  </ng-container>

  <!-- CURRENT SLIDE -->
  <ng-container *ngIf="canBeDisplayed && (item && item.url)">
    <img *ngIf="item.type === 'image'"
      #img
      [src]="item.url"
      [class]="item.fileLoading ? 'opacity-0' : 'fadeIn'"
      [style.object-fit]="parent.fitContent"
      [class.cursor-pointer]="parent.canClickToExpandImage"
      (load)="item.fileLoading = false"
      (error)="item.fileLoading = false"
      (click)="!item.fileLoading && parent.openItem(item)"
    />
    <ng-container *ngIf="item.type === 'video'">
      <video
        *ngIf="!parent?.videoTemplateRef"
        #video
        class="fadeIn"
        [style.object-fit]="parent.fitContent"
        [src]="item.url"
        [controls]="size.isXS && parent.videoControls"
        [class.cursor-pointer]="parent.canClickToExpandImage"
        [tabindex]="parent.canClickToExpandImage ? 0 : -1"
        (mouseenter)="onVideoMouseEnter($event.target)"
        (mouseleave)="onVideoMouseLeave($event.target)"
        (error)="item.fileLoading = false"
        (loadeddata)="item.fileLoading = false"
        (play)="parent.onVideoPlay.emit($event.target)"
        (pause)="parent.onVideoPause.emit()"
        (ended)="parent.onVideoEnd.emit()"
        (click)="!item.fileLoading && parent.openItem(item)"
        (keydown.enter)="!item.fileLoading && parent.openItem(item)"
      ></video>

      <ng-container
        *ngIf="parent?.videoTemplateRef"
        [ngTemplateOutlet]="parent?.videoTemplateRef"
        [ngTemplateOutletContext]="{
          videoSrc: item.url,
        }"
      ></ng-container>
    </ng-container>

    <!-- LOADING IMAGE STATE -->
    <div
      *ngIf="item.fileLoading"
      [@fadeIn]="{ value: ':enter' }"
      [@fadeOut]="{ value: ':leave' }"
      class="absolute inset-0 flex items-center justify-center"
      [ngClass]="parent.isDark ? 'text-white' : 'text-primary'"
    >
      <div
        class="absolute inset-0 opacity-50"
        [ngClass]="parent.isDark ? 'bg-gray-900' : 'bg-white'"
      ></div>
      <mat-spinner
        class="relative z-99 text-current"
        diameter="24"
      />
    </div>

    <!-- REMOVE BUTTON -->
    <button
      *ngIf="parent.editMode"
      class="fadeIn"
      mat-icon-button
      class="absolute top-3 right-3 flex w-6 h-6 min-h-6 bg-primary text-on-primary"
      (click)="parent.emitDeleteItem(item)"
      [matTooltip]="'Remover' | transloco"
    >
      <mat-icon
        class="icon-size-4.5 text-current"
        svgIcon="heroicons_solid:trash"
      />
    </button>
  </ng-container>
</ng-container>
